import React from 'react';
import { Button } from './ui/Button';
import { TrustBadges } from './ui/TrustBadges';
import { PaymentMethods } from './ui/PaymentMethods';
export function Footer() {
  return <footer className="bg-brand-dark pt-12 pb-8 md:pt-16 md:pb-12 px-4 border-t border-zinc-800" data-id="element-60">
      <div className="max-w-2xl mx-auto text-center" data-id="element-61">
        <h2 className="text-2xl md:text-5xl font-bold mb-3 md:mb-4" data-id="element-62">
          STOP IMPROVISING{' '}
          <span className="text-brand-orange" data-id="element-63">EVERY WEEK.</span>
        </h2>
        <p className="text-sm md:text-base text-zinc-400 mb-6 md:mb-8 max-w-xl mx-auto" data-id="element-64">
          Functional & Cross Ready gives you the complete system to prepare
          sessions in minutes and coach with the professionalism your athletes
          deserve. Less time staring at a blank page — more time coaching.
        </p>

        <div className="bg-zinc-900 rounded-2xl border border-zinc-800 p-5 md:p-7 mb-8 shadow-2xl shadow-brand-blue/5" data-id="element-65">
          <div className="flex items-center justify-center gap-3 mb-1" data-id="element-66">
            <span className="text-xl md:text-2xl text-zinc-500 line-through font-bold" data-id="element-67">
              $235
            </span>
            <span className="inline-block bg-emerald-500/15 border border-emerald-500/40 text-emerald-400 text-xs md:text-sm font-bold px-2.5 py-1 rounded-md" data-id="element-68">
              86% OFF
            </span>
          </div>
          <div className="text-4xl md:text-6xl font-bold text-white text-glow-blue leading-none mb-2" data-id="element-69">
            $27
          </div>
          <p className="text-zinc-400 text-xs md:text-sm mb-5" data-id="element-70">
            One-time payment · Instant access
          </p>

          <Button fullWidth size="xl" className="mb-3" onClick={() => window.open('https://functional-cross-ready.impultienda.ar/checkout', '_self')} data-id="element-71">
            YES — I WANT IT NOW
          </Button>

          <p className="text-[11px] md:text-xs text-zinc-500 italic mb-5" data-id="element-72">
            Everything you need to coach with confidence — starting today.
          </p>

          <TrustBadges className="mb-5" data-id="element-73" />

          <p className="text-center text-[10px] md:text-xs text-zinc-500 font-bold tracking-widest uppercase mb-3" data-id="element-74">
            Accepted Payments
          </p>
          <PaymentMethods data-id="element-75" />
        </div>

        <div className="pt-6 md:pt-8 border-t border-zinc-800 text-[10px] md:text-xs text-zinc-600" data-id="element-76">
          <p className="mb-2 md:mb-3" data-id="element-77">
            © 2026 Functional & Cross Ready — All Rights Reserved. Unauthorized
            reproduction and redistribution strictly prohibited.
          </p>
          <p className="max-w-2xl mx-auto" data-id="element-78">
            Our products and content are strictly educational and informational
            in nature. Individual results vary and depend entirely on the
            commitment, skills and personal application of each user.
          </p>
        </div>
      </div>
    </footer>;
}